( function ( _s ) {
	const tyPageUrl = _s( '[data-ty-page]' ).attr( 'data-ty-page' );

	_s.fn.donationForm = function () {
		return this.el.forEach( form => {
			let _form = _s( form );

			const observerCallback = mutationsList => {
				for ( const mutation of mutationsList ) {
					if (
						mutation.type === 'childList' &&
						_form.find( '#bboxmembership_divThanks, #bboxdonation_divThanks' ).length &&
						tyPageUrl &&
						tyPageUrl.toString().length
					) {
						const _donationInfo = _form
							.find( '#bboxmembership_divThanks, #bboxdonation_divThanks' )
							.firstElement();
						let donationInfoHTML = '';

						if ( _donationInfo.attr( 'id' ) == 'bboxmembership_divThanks' ) {
							const _table = _donationInfo.find( 'table' ).removeAttr( 'style' );
							const _additionalInfo = _donationInfo.find(
								'.BBFormConfirmationGiftContainer'
							);
							donationInfoHTML = _table.outerHtml() + _additionalInfo.outerHtml();
						} else {
							donationInfoHTML = _donationInfo.outerHtml();
						}

						window.location.href =
							tyPageUrl + '?summary=' + encodeURIComponent( donationInfoHTML );
					}
				}
			};

			const observer = new MutationObserver( observerCallback );

			const config = {
				attributes: false,
				childList: true,
				subtree: true,
			};

			observer.observe( form, config );
		} );
	};

	_s( document ).ready( () => {
		const _forms = _s( 'body.redirect-to-ty-page #main [id^="bbox-root"]' );

		if ( _forms.length ) {
			_forms.donationForm();
		}
	} );
} )( window._s );
